import { FormProvider, useForm } from 'react-hook-form';
import { Outlet } from 'react-router';
import { MaterialType, Product, Shape } from '@steelbuy/ts-shared';
import { SuccessErrorNotificationContextProvider, WizardStepsContextProvider } from '@steelbuy/ui-primitive';
import { BulkListingContextProvider } from '../../components/bulk-listing/bulk-listing-context/BulkListingContext';
import { BULK_LISTING_STEPS } from '../../components/bulk-listing/bulkListingUtil';

export const BulkListingView = () => {
    const methods = useForm({
        defaultValues: {
            autoRenew: true,
            materialType: MaterialType.MILD_STEEL,
            shape: Shape.FLAT,
            product: Product.COIL,
            prime: true,
        },
    });
    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(() => {})}>
                <BulkListingContextProvider>
                    <SuccessErrorNotificationContextProvider>
                        <WizardStepsContextProvider steps={BULK_LISTING_STEPS}>
                            <Outlet />
                        </WizardStepsContextProvider>
                    </SuccessErrorNotificationContextProvider>
                </BulkListingContextProvider>
            </form>
        </FormProvider>
    );
};
